const validateTemplateBase64Data = (base64String) => {
    // Check if the input is a string
    if (typeof base64String !== 'string') {
        console.log('Input is not a string');
        return false;
    }

    // Check if the string is not empty
    if (base64String.length === 0) {
        console.log('Input string is empty');
        return false;
    }

    // Check if the string starts with "Rk1SACAy"
    if (!base64String.startsWith('Rk1SACAy')) {
        console.log('String does not start with "Rk1SACAy"');
        return false;
    }

    // Check if the string ends with "AAAA"
    if (!base64String.endsWith('AAAA')) {
        console.log('String does not end with "AAAA"');
        return false;
    }

    // Check the length of the string (if needed)
    // const expectedLength = 280; // Example length, adjust based on your requirements
    // if (base64String.length !== expectedLength) {
    //     console.log('Invalid string length');
    //     return false;
    // }

    // Validate the string with the Base64 regex without equals signs (if needed)
    // const base64Regex = /^[A-Za-z0-9+/]+$/;
    // if (!base64Regex.test(base64String)) {
    //     console.log('String contains invalid characters');
    //     return false;
    // }

    // If all conditions pass, return true
    return true;
};

export default validateTemplateBase64Data;
